import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

import { useOnMount } from '../../hooks';
import { useCognito } from '../../providers/CognitoProvider';

const FederatedSignIn = () => {
  const { federatedSingIn } = useCognito();

  useOnMount(federatedSingIn);

  return (
    <Box
      width="100%"
      height="90vh"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
      <Typography component={Box} my={2} color="white" data-testid="loader">
        Redirecting
      </Typography>
      <CircularProgress color="info" size={50} thickness={1} />
    </Box>
  );
};

export default FederatedSignIn;
